import { useEffect, useState } from "react";
import { WhatsappLogo } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export const WhatsAppButton = ({ defaultNumber = "5532999103556", defaultMessage = "Olá! Preciso de ajuda." }) => {
  const [link, setLink] = useState(`https://wa.me/${defaultNumber}?text=${encodeURIComponent(defaultMessage)}`);

  useEffect(() => {
    api.get("/public/whatsapp")
      .then(({ data }) => setLink(data.url))
      .catch(() => {});
  }, []);

  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-floating-btn"
      className="wa-pulse fixed bottom-24 sm:bottom-20 lg:bottom-6 right-5 z-50 rounded-full bg-[#25D366] text-white p-4 shadow-lg hover:-translate-y-0.5 transition-transform"
      aria-label="Suporte via WhatsApp"
    >
      <WhatsappLogo size={28} weight="fill" />
    </a>
  );
};

export default WhatsAppButton;
